import { CenteredLayout } from '@/components/layouts/CenteredLayout';
import { withAuthGuard } from '@/hoc/withAuthGuard';
import { TransText } from '@/i18n/trans/text';
import { breakpoints } from '@/utils/breakpoints';
import { Card, Icons, Typography } from '@packages/webshop-design-system';
import { type FC, useEffect } from 'react';
import { useMediaQuery } from 'react-responsive';
import { useLocation, useNavigate } from 'react-router-dom';

interface SignupConfirmationProps {}

const SignupConfirmationComponent: FC<SignupConfirmationProps> = () => {
  const isLaptopOrBigger = useMediaQuery({
    minWidth: breakpoints.laptop,
  });
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!location.state?.id) {
      navigate('/signup');
    }
  }, [location, navigate]);

  return (
    <CenteredLayout>
      <div className="mx-4 mt-10 laptop:mx-auto laptop:max-w-[410px]">
        <Typography
          variant={isLaptopOrBigger ? 'title' : 'mobile-title'}
          className="text-left"
          as="h1"
        >
          <TransText i18nKey="confirmRegistration" />
        </Typography>
        <Card className="mt-8 flex flex-col gap-4 rounded-xl">
          <div className="flex items-center gap-2">
            <Icons.checkCircle className="text-success-text" />
            <Typography variant="subtitle">
              <TransText i18nKey="checkYourEmail" />
            </Typography>
          </div>
          <Typography variant="body1">
            <TransText i18nKey="confirmRegistrationDescription" />
          </Typography>
        </Card>
      </div>
    </CenteredLayout>
  );
};

const SignupConfirmation = withAuthGuard('loginOrSignup')(
  SignupConfirmationComponent
);

export default SignupConfirmation;
